import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as LogRocket from 'logrocket';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();

  if (environment.logRocketKey) {
    LogRocket.init(environment.logRocketKey, {
      console: {
        shouldAggregateConsoleErrors: true,
      },
    });
  }
}

void platformBrowserDynamic().bootstrapModule(AppModule);
